import React, { useState } from "react";
import { useRecoilValue } from "recoil";
import { authState } from "recoil/auth";
import Header from "../modules/layout/Header";
import useApplyActions from "../../api/hooks/apply";
import { useQuery } from "@tanstack/react-query";
import ExamResultTable from "../modules/layout/ExamResultTable";
import { speakLanguageToKorean } from "../../static";

const ExamComplete = () => {
  const auth = useRecoilValue(authState);
  const applyActions = useApplyActions();
  const [refetchInterval, setRefetchInterval] = useState(1000);
  // const room_type = auth?.data?.room_type;
  // const koreanTitle = speakLanguageToKorean(room_type);

  let hostURL = "https://" + window.location.hostname;

  if (hostURL.includes("localhost")) {
    hostURL = "https://opic.airsoundtest.com";
  }

  const { data: videoUrlList } = useQuery({
    queryKey: ["getExamResult"],
    queryFn: () => applyActions.getExamResult(),
    refetchInterval,
    onSuccess: () => {
      if (videoUrlList?.data?.length === 15) {
        setRefetchInterval(0);
      }
    },
  });

  return (
    <div>
      <Header />
      <div className="base-sec">
        <div className="background-color-w">
          <div className="base-sec-top flex">
            <div>
              <p className="title">외국어 말하기 평가</p>
            </div>
          </div>
          <div className="base-sec-sec exam-complete-sec">
            <div className="page-title text-align-center">
              <p>응시완료</p>
            </div>

            <div className="complete-box text-align-center">
              {/* <p className="complete-text">
                수고하셨습니다. KOICA 해외봉사단 언어역량 진단평가가 정상적으로
                완료되었습니다.
                <br></br>
                응시 결과는 시험 종료 후 약 3주 이내에 이메일로 안내 됩니다.
              </p> */}
              {/* <p className="complete-ex">
                <b>응시 결과</b>는 시험 종료 후{" "}
                <span className="text-blue">약 3주 이내에 이메일로 안내</span>
                됩니다.
                <br />
                Data 활용 지원금은 주관기관인 ㈜에스엘아이평생교육원에서
                응시자분들의 시험 결과를 확인 후
                <br />
                본인 명의의 금융기관 계좌로 2022년 12월 31일 내 입금해 드릴
                예정입니다.
                <br />
                감사합니다.
                <br />
              </p> */}
            </div>
            <div className="exam-complete-table-box">
              <div>
                <table className="exam-complete-table">
                  <caption>지원자 및 응시 현황</caption>
                  <thead>
                    <tr>
                      <th>이름</th>
                      <th>수험번호</th>
                      <th>응시상태</th>
                      {/*<th>완료일자</th>*/}
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="text-align-center">
                      <td>{auth.user.payload.user_name}</td>
                      <td>{auth.user.payload.user_id}</td>
                      <td>응시완료</td>
                      {/*<td>202-09-06 13:08:10</td>*/}
                    </tr>
                  </tbody>
                </table>
              </div>
              <br></br>
              <div>
                <table className="exam-complete-table">
                  <caption>제출결과확인</caption>
                  <ExamResultTable videoUrlList={videoUrlList?.data} />
                </table>
              </div>
            </div>
            <div className="base-sec-bottom text-align-center">
              <button
                className="bottombtn bottombtn-b"
                onClick={() => {
                  window.location.reload();
                }}
              >
                종료
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExamComplete;
